"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6076,440],{

/***/ 37247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HeaderInfoIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var HeaderInfoIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        id: "information",
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "13.757",
        height: props.height || "16.008",
        viewBox: "0 0 13.757 16.008",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Group_160946",
            "data-name": "Group 160946",
            transform: "translate(0 0)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Group_160945",
                "data-name": "Group 160945",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Path_229366",
                        fill: props.color || "#000",
                        "data-name": "Path 229366",
                        d: "M234.921,182.774c-.4,0-.68.168-.68.415v3.366c0,.212.283.424.68.424.38,0,.689-.212.689-.424v-3.366C235.611,182.942,235.3,182.774,234.921,182.774Z",
                        transform: "translate(-228.043 -177.06)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Path_229367",
                        fill: props.color || "#000",
                        "data-name": "Path 229367",
                        d: "M233.553,116.361a.637.637,0,1,0,.716.627A.684.684,0,0,0,233.553,116.361Z",
                        transform: "translate(-226.674 -112.723)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Path_229368",
                        fill: props.color || "#000",
                        "data-name": "Path 229368",
                        d: "M42.878,0A6.875,6.875,0,0,0,40.8,13.428l1.564,2.306a.625.625,0,0,0,1.035,0l1.564-2.306A6.875,6.875,0,0,0,42.878,0ZM44.4,12.29a.625.625,0,0,0-.349.251l-1.172,1.727-1.172-1.727a.625.625,0,0,0-.349-.251,5.628,5.628,0,1,1,3.042,0Z",
                        transform: "translate(-36 0)"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 50127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function SearchIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 24.295,
        height: props.size || 24.295,
        viewBox: "0 0 24.295 24.295"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.018 22.683l-5.929-5.929a10.24 10.24 0 10-1.336 1.336l5.929 5.929a.945.945 0 101.336-1.336zM1.889 10.226a8.336 8.336 0 118.336 8.336 8.346 8.346 0 01-8.336-8.336z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 52514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ UserIconDark; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var UserIconDark = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "33",
        height: props.height || "33",
        viewBox: "0 0 33 33",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Group_160983",
            "data-name": "Group 160983",
            transform: "translate(-1002.137 -16.628)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "User",
                transform: "translate(1002.413 16.903)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        id: "Ellipse_5156",
                        "data-name": "Ellipse 5156",
                        cx: "16.5",
                        cy: "16.5",
                        r: "16.5",
                        transform: "translate(-0.275 -0.275)",
                        fill: "#efefef"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "Group_160982",
                        "data-name": "Group 160982",
                        transform: "translate(3.728 6.554)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                id: "Path_296382",
                                "data-name": "Path 296382",
                                d: "M32.084,44.26a15.588,15.588,0,0,0-24.972-.008,15.539,15.539,0,0,0,24.972.008Z",
                                transform: "translate(-7.112 -24.671)",
                                fill: props.color || "#464e58"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                id: "Ellipse_5157",
                                "data-name": "Ellipse 5157",
                                cx: "5.896",
                                cy: "5.896",
                                r: "5.896",
                                transform: "translate(6.593 0)",
                                fill: props.color || "#464e58"
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 72651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);











// env
var inBrowser = "object" !== "undefined";
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
var Dialog = function(props) {
    var animation = (props.animationType === "enter" ? props.enterAnimation : props.leaveAnimation) || props.animation;
    var className = "rodal-dialog rodal-".concat(animation, "-").concat(props.animationType);
    var CloseButton = props.showCloseButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "rodal-close",
        onClick: props.onClose,
        children: "Close"
    }) : null;
    var width = props.width, height = props.height, measure = props.measure, duration = props.duration, customStyles = props.customStyles;
    var style = {
        width: width + "%",
        minHeight: height + measure,
        animationDuration: duration + "ms",
        WebkitAnimationDuration: duration + "ms"
    };
    var mergedStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, style, customStyles);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: mergedStyles,
        className: className,
        children: [
            props.children,
            CloseButton
        ]
    });
};
var _Component;
var rodal = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(rodal, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(rodal);
    function rodal() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, rodal);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "state", {
            isShow: false,
            animationType: "leave"
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onKeyUp", function(event) {
            if (_this.props.closeOnEsc && event.keyCode === 27) {
                _this.props.onClose();
            }
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "animationEnd", function(event) {
            if (_this.state.animationType === "leave") {
                _this.setState({
                    isShow: false
                });
            } else if (_this.props.closeOnEsc) {
                _this.el.focus();
            }
            if (event.target === _this.el) {
                var onAnimationEnd = _this.props.onAnimationEnd;
                onAnimationEnd && onAnimationEnd();
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(rodal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.visible) {
                    this.enter();
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (!this.props.visible && nextProps.visible) {
                    this.enter();
                } else if (this.props.visible && !nextProps.visible) {
                    this.leave();
                }
            }
        },
        {
            key: "enter",
            value: function enter() {
                this.setState({
                    isShow: true,
                    animationType: "enter"
                });
                document.getElementsByTagName("html")[0].style.overflow = "hidden";
            }
        },
        {
            key: "leave",
            value: function leave() {
                this.setState(isIE9 ? {
                    isShow: false
                } : {
                    animationType: "leave"
                });
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.getElementsByTagName("body")[0].style.overflowY = "";
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref = this, props = ref.props, state = ref.state;
                var onClick = props.closeMaskOnClick ? props.onClose : null;
                var mask = props.showMask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rodal-mask",
                    style: props.customMaskStyles,
                    onClick: onClick
                }) : null;
                var style = {
                    display: state.isShow ? "block" : "none",
                    animationDuration: props.duration + "ms",
                    WebkitAnimationDuration: props.duration + "ms"
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: style,
                    className: "rodal rodal-fade-" + state.animationType + " " + props.className,
                    onAnimationEnd: this.animationEnd,
                    tabIndex: "-1",
                    ref: function(el) {
                        _this.el = el;
                    },
                    onKeyUp: this.onKeyUp,
                    children: [
                        mask,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                            animationType: state.animationType,
                            children: props.children
                        }))
                    ]
                });
            }
        }
    ]);
    return rodal;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "propTypes", {
    width: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    height: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
    ]),
    measure: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    visible: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showMask: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeOnEsc: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeMaskOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    animation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    enterAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    leaveAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    duration: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    customStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    customMaskStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    onAnimationEnd: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func)
});
// ...
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "defaultProps", {
    width: 100,
    height: 300,
    measure: "px",
    visible: false,
    showMask: true,
    closeOnEsc: false,
    closeMaskOnClick: true,
    showCloseButton: false,
    animation: "zoom",
    enterAnimation: "",
    leaveAnimation: "",
    duration: 300,
    className: "",
    customStyles: {},
    customMaskStyles: {}
});
/* harmony default export */ __webpack_exports__["Z"] = (rodal);


/***/ }),

/***/ 70440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ReactHamburger; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/Common/ReactHamburger/index.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 5%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 22px;\n  height: 22px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 10;\n  flex: 0 0 auto;\n\n  &:focus {\n    outline: none;\n  }\n\n  & div {\n    background: ",
        ";\n  }\n\n  div {\n    width: 100%;\n    height: 2px;\n    border-radius: 10px;\n    transition: all 0.3s linear;\n    position: relative;\n    transform-origin: 1px;\n\n    :first-child {\n      transform: ",
        ";\n    }\n\n    :nth-child(2) {\n      opacity: ",
        ";\n      transform: ",
        ";\n    }\n\n    :nth-child(3) {\n      transform: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledBurger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "StyledBurger",
    componentId: "sc-52da0d30-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme ? theme : "#000000";
}, function(param) {
    var open = param.open;
    return open ? "rotate(45deg)" : "rotate(0)";
}, function(param) {
    var open = param.open;
    return open ? "0" : "1";
}, function(param) {
    var open = param.open;
    return open ? "translateX(-20px)" : "translateX(0)";
}, function(param) {
    var open = param.open;
    return open ? "rotate(-45deg)" : "rotate(0)";
});

;// CONCATENATED MODULE: ./src/components/Common/ReactHamburger/index.js



var Burger = function(param) {
    var open = param.open, setOpen = param.setOpen, theme = param.theme, _style = param.style, style = _style === void 0 ? {} : _style, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? null : _showIcon, _showDiffIcon = param.showDiffIcon, showDiffIcon = _showDiffIcon === void 0 ? false : _showDiffIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            showDiffIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setOpen(!open);
                },
                children: showIcon === null || showIcon === void 0 ? void 0 : showIcon()
            }),
            !showDiffIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBurger, {
                style: style,
                open: open,
                onClick: function() {
                    return setOpen(!open);
                },
                theme: theme,
                "aria-label": "menu",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                ]
            })
        ]
    });
};
/* harmony default export */ var ReactHamburger = (Burger);


/***/ }),

/***/ 93080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ btnActionHandler; }
/* harmony export */ });
/* harmony import */ var _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67306);

var redirectToNewLink = function(link, newTab) {
    if (!link) return;
    if (newTab) {
        window.open(link, "_blank");
    } else {
        window.location.href = link;
    }
};
var downloadButton = function(link) {
    if (!link) return;
    var downloadLink = document.createElement("a");
    downloadLink.href = "".concat(link, "?download=true");
    downloadLink.target = "_blank";
    downloadLink.rel = "noopener noreferrer";
    downloadLink.download = "file";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
var scrollToElement = function(id) {
    if (!id) return;
    var elementContainer = document.getElementById(id);
    if (elementContainer) {
        window.scrollTo({
            behavior: "smooth",
            top: elementContainer.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 5
        });
    }
};
var renderFormComponent = function(handler, callback) {
    callback && callback();
};
var btnActionHandler = function(param) {
    var type = param.type, handler = param.handler, newTab = param.newTab, callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    switch(type){
        case 1:
        case _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECTION_TYPES.link */ .Qf.link:
            redirectToNewLink(handler, newTab);
            break;
        case 2:
            renderFormComponent(handler, callback);
            break;
        case 3:
        case _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECTION_TYPES.scrollto */ .Qf.scrollto:
            scrollToElement(handler);
            break;
        case 4:
            downloadButton(handler);
            break;
        case 5:
            return;
    }
};


/***/ }),

/***/ 69153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ logoSectionConfigDetails; },
/* harmony export */   "R0": function() { return /* binding */ getHamburgerCustomList; },
/* harmony export */   "RA": function() { return /* binding */ isWebFrameRoute; },
/* harmony export */   "qd": function() { return /* binding */ useGetNavlinkList; }
/* harmony export */ });
/* unused harmony export getMaxCharactersAllowedInNavLinks */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29492);
/* harmony import */ var src_redux_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24686);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6337);
/* harmony import */ var _ModernTheme_utils_btnUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93080);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);








var logoSectionConfigDetails = function(activeHeaderData, isScroll) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var headerPropsConfig = (activeHeaderData || {}).headerPropsConfig;
    var ref7 = headerPropsConfig || {}, logo_section = ref7.logo_section, globalClass = ref7.globalClass;
    var ref8 = logo_section || {}, staticLogo = ref8.staticLogo, scrollLogo = ref8.scrollLogo;
    var currentType = isScroll ? scrollLogo : staticLogo;
    var isTransparent = (globalClass === null || globalClass === void 0 ? void 0 : (ref = globalClass.staticClass) === null || ref === void 0 ? void 0 : (ref1 = ref.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultFillColorType) === "transparent";
    var ref9 = (scrollLogo === null || scrollLogo === void 0 ? void 0 : (ref2 = scrollLogo.componentData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.url) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && isTransparent ? currentType : staticLogo, base_config = ref9.base_config, url = ref9.componentData.url;
    var storeName = (ref4 = src_redux_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().storeReducer.store) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.store_info) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.name) === null || ref6 === void 0 ? void 0 : ref6.trim();
    return {
        hidden: !(base_config.showLogo || base_config.showStoreName),
        onlyLogo: base_config.showLogo && url && !(base_config.showStoreName && storeName),
        onlyStoreName: base_config.showStoreName && storeName && !(base_config.showLogo && url),
        logoAndName: base_config.showStoreName && storeName && base_config.showLogo && url
    };
};
function getApproxCharLengthAllowed(param) {
    var _preferredWidth = param.preferredWidth, preferredWidth = _preferredWidth === void 0 ? 720 : _preferredWidth, _charLengthAllowed = param.charLengthAllowed, charLengthAllowed = _charLengthAllowed === void 0 ? 56 : _charLengthAllowed, maxCharactersLimit = param.maxCharactersLimit;
    var calculatedChar = Math.floor(charLengthAllowed * (preferredWidth / 720));
    return calculatedChar > maxCharactersLimit ? maxCharactersLimit : calculatedChar;
}
function getMaxCharactersAllowedInNavLinks(param) {
    var containerRef = param.containerRef, headerName = param.headerName, isBuilder = param.isBuilder, headerWidth = param.headerWidth, navlinksPosition = param.navlinksPosition, searchBarType = param.searchBarType;
    var ref;
    var sectionWidth = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
    var preferredWidth = (isBuilder ? sectionWidth : headerWidth) - 18;
    var charLengthAllowed = "unset";
    if (headerName === "header1") {
        if (preferredWidth <= 720) {
            if (searchBarType === "field") charLengthAllowed = navlinksPosition === "left" ? 17 : 7;
            if (searchBarType === "icon") charLengthAllowed = 21;
            if (searchBarType === "labelIcon") charLengthAllowed = 21;
        }
        if (preferredWidth > 720 && preferredWidth < 1280) {
            if (searchBarType === "field") charLengthAllowed = navlinksPosition === "left" ? 17 : 7;
            if (searchBarType === "icon") charLengthAllowed = 21;
            if (searchBarType === "labelIcon") charLengthAllowed = 21;
        }
        if (preferredWidth >= 1280 && preferredWidth <= 1500) {
            if (searchBarType === "field") charLengthAllowed = 20;
            if (searchBarType === "icon") charLengthAllowed = 58;
            if (searchBarType === "labelIcon") charLengthAllowed = 53;
        }
        if (preferredWidth > 1500 && preferredWidth <= 1800) {
            if (searchBarType === "field") charLengthAllowed = 34;
            if (searchBarType === "icon") charLengthAllowed = 77;
            if (searchBarType === "labelIcon") charLengthAllowed = 64;
        }
        if (preferredWidth > 1800) {
            if (searchBarType === "field") charLengthAllowed = 70;
            if (searchBarType === "icon") charLengthAllowed = 92;
            if (searchBarType === "labelIcon") charLengthAllowed = 81;
        }
    }
    if (headerName === "header2") {
        if (preferredWidth <= 720) {
            charLengthAllowed = 16;
        }
        if (preferredWidth > 720 && preferredWidth <= 1100) {
            charLengthAllowed = 15;
        }
        if (preferredWidth > 1100 && preferredWidth <= 1500) {
            charLengthAllowed = 31;
        }
        if (preferredWidth > 1500 && preferredWidth <= 1800) {
            charLengthAllowed = 35;
        }
        if (preferredWidth > 1800) {
            charLengthAllowed = 49;
        }
    }
    if (headerName === "header3" || headerName === "header4") {
        if (preferredWidth > 720 && preferredWidth <= 999) {
            charLengthAllowed = 56;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 100
            });
        }
        if (preferredWidth >= 1000 && preferredWidth <= 1262) {
            charLengthAllowed = 70;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 100
            });
        }
        if (preferredWidth > 1262 && preferredWidth <= 1347) {
            charLengthAllowed = 70;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 104
            });
        }
        if (preferredWidth > 1347 && preferredWidth <= 1421) {
            charLengthAllowed = 104;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 133
            });
        }
        if (preferredWidth > 1421 && preferredWidth <= 1517) {
            charLengthAllowed = 111;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 140
            });
        }
        if (preferredWidth > 1517 && preferredWidth <= 1581) {
            charLengthAllowed = 116;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 140
            });
        }
        if (preferredWidth > 1581 && preferredWidth <= 1782) {
            charLengthAllowed = 132;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 160
            });
        }
        if (preferredWidth > 1782) {
            charLengthAllowed = 140;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 170
            });
        }
    }
    return charLengthAllowed;
}
function checkForShopComponent(linksData) {
    linksData === null || linksData === void 0 ? void 0 : linksData.forEach(function(data) {
        var ref;
        if ((data === null || data === void 0 ? void 0 : data.isShopComponent) && (data === null || data === void 0 ? void 0 : (ref = data.option) === null || ref === void 0 ? void 0 : ref.length) && (data === null || data === void 0 ? void 0 : data.type) === "text") {
            data.type = "dropdown";
            data.redirectionLink = "";
        }
    });
    return (0,lodash__WEBPACK_IMPORTED_MODULE_6__.cloneDeep)(linksData);
}
var useGetNavlinkList = function(param) {
    var activeHeaderData = param.activeHeaderData, headerData = param.headerData, dynamicSectionData = param.dynamicSectionData, headerNodeRef = param.headerNodeRef, isBuilder = param.isBuilder, componentData = param.componentData, headerName = param.headerName, containerRef = param.containerRef;
    var checkIfMoreAlreadyThere = function checkIfMoreAlreadyThere(visibleLinks) {
        var moreIndex = -1;
        for(var i = 0; i < (visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length); i++){
            var ref, ref1;
            if (((ref = visibleLinks[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "more") {
                moreIndex = i;
                break;
            }
        }
        return moreIndex;
    };
    var removeMoreOption = function removeMoreOption(restElements) {
        return restElements === null || restElements === void 0 ? void 0 : restElements.filter(function(data) {
            var ref;
            return (data === null || data === void 0 ? void 0 : (ref = data.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== "more";
        });
    };
    var getNavLinkSliceCount = function getNavLinkSliceCount() {
        var charLengthAllowed = getMaxCharactersAllowedInNavLinks({
            containerRef: containerRef,
            headerName: headerName,
            isBuilder: isBuilder,
            headerWidth: headerWidth,
            navlinksPosition: navlinksPosition,
            searchBarType: searchBarType
        });
        var sliceCount = 0;
        if (charLengthAllowed === "unset") {
            return sliceCount;
        }
        var currentCharacterCount = 0;
        for(var currentIndex = 0; currentIndex <= visibleLinks.length - 1; currentIndex++){
            currentCharacterCount = currentCharacterCount + visibleLinks[currentIndex].name.length;
            if (currentCharacterCount > charLengthAllowed) {
                break;
            } else {
                ++sliceCount;
            }
        }
        return sliceCount;
    };
    var ref, ref1, ref2;
    var headerWidth = (headerNodeRef === null || headerNodeRef === void 0 ? void 0 : headerNodeRef.clientWidth) || (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__/* .IS_SERVER */ .W6 ? window.innerWidth : 0);
    var navlinksPosition = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.navLinks_section) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultPosition;
    var visibleLinks = componentData === null || componentData === void 0 ? void 0 : componentData.filter(function(data) {
        return data === null || data === void 0 ? void 0 : data.showOnHeader;
    });
    var dynamicSectionBaseConfig = dynamicSectionData.base_config;
    var searchBarType = dynamicSectionBaseConfig.defaultType;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), navlinkList = ref3[0], setNewList = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // let sliceCount = componentData?.length;
        var sliceCount = 1;
        sliceCount = getNavLinkSliceCount();
        var newComponentData = [];
        if (sliceCount > (visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length)) {
            newComponentData = visibleLinks;
        } else {
            var currentData = visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.slice(0, sliceCount);
            var restElements = visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.slice(sliceCount, visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length);
            var newData = [];
            var moreIndex = checkIfMoreAlreadyThere(visibleLinks);
            if (restElements === null || restElements === void 0 ? void 0 : restElements.length) {
                var ref;
                newData = {
                    name: "More",
                    type: "dropdown",
                    option: moreIndex >= 0 ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(removeMoreOption(restElements)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(visibleLinks === null || visibleLinks === void 0 ? void 0 : (ref = visibleLinks[moreIndex]) === null || ref === void 0 ? void 0 : ref.option)) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(restElements),
                    showOnHeader: true,
                    elementLevelClass: ""
                };
            }
            newComponentData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((restElements === null || restElements === void 0 ? void 0 : restElements.length) > 0 ? removeMoreOption(currentData) : currentData).concat([
                newData, 
            ]);
        }
        setNewList(newComponentData);
    }, [
        componentData,
        headerName,
        componentData === null || componentData === void 0 ? void 0 : componentData.length,
        visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length
    ]);
    var updatedNavLinks = checkForShopComponent(navlinkList);
    return {
        navlinkList: updatedNavLinks
    };
};
var getHamburgerCustomList = function(activeHeaderData, onMenuDrawerItemClick, toggleMenuDrawerOnMobile, canShowItem) {
    var ref, ref1, ref2, ref3, ref4;
    var drawerCustomList = ((ref = activeHeaderData.headerPropsConfig.navIcons_section) === null || ref === void 0 ? void 0 : (ref1 = ref.componentData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iconsList) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
        var ref;
        return ((ref = item.visibility) === null || ref === void 0 ? void 0 : ref.hamburger) === true;
    }).reverse().map(function(item) {
        return canShowItem(item) && item.name === "loginLogout" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            disableDropdown: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: item.label
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "tw-m-0 ",
            onClick: function() {
                return onMenuDrawerItemClick(item.action.actionType, item.action.actionData);
            },
            children: item.label
        }, item.label);
    })) || [];
    var visibleButtons = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref3 = activeHeaderData.headerPropsConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.buttons) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
        var ref;
        return !!(item === null || item === void 0 ? void 0 : item.isShow) && !!(item === null || item === void 0 ? void 0 : (ref = item.text) === null || ref === void 0 ? void 0 : ref.trim());
    });
    var buttonList = (visibleButtons === null || visibleButtons === void 0 ? void 0 : visibleButtons.map(function(item) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "tw-m-0 ",
            onClick: function() {
                toggleMenuDrawerOnMobile(false);
                (0,_ModernTheme_utils_btnUtils__WEBPACK_IMPORTED_MODULE_5__/* .btnActionHandler */ .c)(item === null || item === void 0 ? void 0 : item.actions, function() {});
            },
            children: item.text
        }, item.text);
    })) || [];
    return (drawerCustomList === null || drawerCustomList === void 0 ? void 0 : drawerCustomList.concat(buttonList)) || [];
};
/**
 * webFrame is the route which only has CFE header and the body is loaded in iFrame
 * @returns if the route is an iFrame route
 */ var isWebFrameRoute = function() {
    if (_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__/* .IS_SERVER */ .W6) {
        return false;
    }
    return window.location.pathname.includes("/webFrame");
};


/***/ }),

/***/ 41771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31024);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);


function useInstallAppOverlayActions() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var showInstallAppOverlay = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            showInstallAppOverlay: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.showInstallAppOverlay
        };
    }).showInstallAppOverlay;
    var openIntallAppOverlay = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .setShowInstallAppOverlay */ .wD)(true));
    };
    var closeIntallAppOverlay = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .setShowInstallAppOverlay */ .wD)(false));
    };
    return {
        showInstallAppOverlay: showInstallAppOverlay,
        openIntallAppOverlay: openIntallAppOverlay,
        closeIntallAppOverlay: closeIntallAppOverlay
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useInstallAppOverlayActions);


/***/ }),

/***/ 29492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33104);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85126);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44541);
/* harmony import */ var _assets_svgExports_UserIconDark__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52514);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25617);
/* harmony import */ var _utils_orderDropdownList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20503);
/* harmony import */ var _LogoutModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21448);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7982);












var LoginComponent = function(props) {
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDropdown(!showDropdown);
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutModal(!showLogoutModal);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showLogoutModal = ref1[0], setShowLogoutModal = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    // const { headerHeight } = useSSRSelector((state) => ({
    //   headerHeight: state.commonReducer?.heightCalculation.headerHeight,
    // }));
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), node = ref2[0], setNode = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return {
            user: state.userReducer,
            storeData: state.storeReducer.store
        };
    }), user = ref3.user, storeData = ref3.storeData;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setShowLogoutModal(false);
    }, [
        user.isLogin
    ]);
    var ordersDropdownList = (0,_utils_orderDropdownList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var iconRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(node) {
        if (!node) {
            return;
        }
        setNode(node);
    }, []);
    var loginClick = function() {
        var ref;
        if ((user === null || user === void 0 ? void 0 : user.isLogin) && !props.disableDropdown) {
            setShowDropdown(!showDropdown);
        } else if ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("/".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.ORDERS))) router.reload();
        else {
            var ref1;
            router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        }
    };
    var onHandleOrdersDropdown = function(item) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref;
        switch(item.action){
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ORDERS_DROPDOWN_LIST.MY_ORDERS */ .Bm.MY_ORDERS:
                {
                    var ref1;
                    toggleShowDesktopDropdown();
                    router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
                    break;
                }
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ORDERS_DROPDOWN_LIST.LOGOUT */ .Bm.LOGOUT:
                {
                    toggleLogoutModal();
                    setShowDropdown(false);
                    break;
                }
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ORDERS_DROPDOWN_LIST.DEFAULT_PHONE */ .Bm.DEFAULT_PHONE:
                {
                    break;
                }
            default:
                {
                    break;
                }
        }
        (ref = props.closeParentContainer) === null || ref === void 0 ? void 0 : ref.call(props);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* .ClickAwayListener */ .d, {
                onClickAway: function() {
                    return setShowDropdown(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: iconRef,
                    className: "relative login-component tw-select-none tw-font-dmSans",
                    style: props.style || {},
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center",
                            onClick: loginClick,
                            children: props.children
                        }),
                        showDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: " absolute z-999 login-component__dropdown",
                            style: {
                                top: node ? (node === null || node === void 0 ? void 0 : node.offsetTop) + (node === null || node === void 0 ? void 0 : node.offsetHeight) : undefined
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "login-component__dropdown--arrow"
                                }),
                                ordersDropdownList === null || ordersDropdownList === void 0 ? void 0 : ordersDropdownList.map(function(item) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "login-component__dropdown--item flex items-center z-5 tw-px-[20px] tw-py-[16px] \n                ".concat((props === null || props === void 0 ? void 0 : props.headerBgColor) && (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_11__/* .getContrastingColor */ .Q)(props === null || props === void 0 ? void 0 : props.headerBgColor) === "#ffffff" && item.id !== 3 ? "filter-invert-1" : "filter-invert-0", " ").concat(item.id === 3 ? "red " : "", " ").concat(item.id !== 1 && "pointer"),
                                        onClick: function(e) {
                                            return onHandleOrdersDropdown(item, e);
                                        },
                                        children: [
                                            item.id === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "tw-mr-[10px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_UserIconDark__WEBPACK_IMPORTED_MODULE_4__/* .UserIconDark */ .q, {
                                                    color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.primary_color,
                                                    width: "33",
                                                    height: "33"
                                                })
                                            }),
                                            item.name
                                        ]
                                    }, item.id);
                                })
                            ]
                        })
                    ]
                })
            }),
            showLogoutModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LogoutModal__WEBPACK_IMPORTED_MODULE_9__["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_2__/* .executeLogout */ .q,
                showLogoutConfirmation: showLogoutModal
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginComponent);


/***/ }),

/***/ 21448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20155);








function LogoutModal(props) {
    var showLogoutConfirmationModal = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return {
            showLogoutConfirmationModal: state.commonReducer.showLogoutConfirmationModal
        };
    }).showLogoutConfirmationModal;
    return _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_MOBILE_WIDTH */ .Cf ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoutDesktopModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        showLogoutConfirmationModal: showLogoutConfirmationModal || props.showLogoutConfirmation
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoutMobileModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        showLogoutConfirmationModal: showLogoutConfirmationModal || props.showLogoutConfirmation
    }));
}
function LogoutMobileModal(props) {
    var executeLogout = function() {
        props.executeLogout();
        props === null || props === void 0 ? void 0 : props.toggleLogoutModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            visible: props.showLogoutConfirmationModal,
            className: "mobile-center-modal margin-top-modal-0 !tw-z-[700]",
            animation: "slideUp",
            width: 85,
            height: 150,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "logout-modal-content-container flex flex-column !tw-z-[700]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center fw7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                color: "black",
                                fontSize: 16,
                                transform: "translate(10px , 11px)",
                                whiteSpace: "nowrap"
                            },
                            children: "Are you sure you want to Logout?"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row justify-end",
                        style: {
                            marginTop: 16,
                            transform: "translateY(24px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex no-container items-center justify-center bg-black-90 br4",
                                onClick: props === null || props === void 0 ? void 0 : props.toggleLogoutModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "white fw6",
                                    children: "No"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex yes-container items-center justify-center br4 bg-white-90",
                                onClick: executeLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "br4 black fw6",
                                    children: "Yes"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function LogoutDesktopModal(props) {
    var executeLogout = function() {
        props.executeLogout();
        props === null || props === void 0 ? void 0 : props.toggleLogoutModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            visible: props.showLogoutConfirmationModal,
            className: "bottom-modal",
            animation: "slideUp",
            width: 30,
            height: 150,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "logout-modal-content-container flex flex-column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            style: {
                                color: "black",
                                marginLeft: 10
                            },
                            children: "Are you sure you want to Logout?"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row justify-end mt4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex no-container items-center justify-center bg-black-90 br4",
                                onClick: props === null || props === void 0 ? void 0 : props.toggleLogoutModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "white fw6",
                                    children: "No"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex yes-container items-center justify-center br4 bg-white-90",
                                onClick: executeLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "br4 black fw6",
                                    children: "Yes"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (LogoutModal);


/***/ }),

/***/ 27560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFeatureLocks; }
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);



function useFeatureLocks() {
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            featureLocks: state.commonReducer.featureLocksData.featureLocks,
            storeData: state.storeReducer.store
        };
    }), featureLocks = ref.featureLocks, storeData = ref.storeData;
    var isEcommExpired = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (storeData === null || storeData === void 0 ? void 0 : storeData.subscription_flag) === _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .SUBSCRIPTION_FLAG.EXPIRED */ .NU.EXPIRED;
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.subscription_flag
    ]);
    var crrFeatureStatus = featureLocks["crr"];
    var couponsFeatureStatus = featureLocks["couponsVouchers"];
    var fbPixelFeatureStatus = featureLocks["fbPixel"];
    var googleAnalyticsFeatureStatus = featureLocks["googleAnalytics"];
    var googleTagFeatureStatus = featureLocks["gtm"];
    var installAppFeatureStatus = featureLocks["installApp"];
    var leadGenFeatureStatus = featureLocks["leadGen"];
    var visitorLoginFeatureStatus = featureLocks["visitorLogin"];
    var collectionsFeatureStatus = featureLocks["collections"];
    var notifyMeFeatureStatus = featureLocks["notifyMe"];
    var partialPaymentFeatureStatus = featureLocks["partialPayment"];
    var memberOnlyLoginFeatureStatus = featureLocks["memberOnlyLogin"];
    return {
        collectionsFeatureStatus: collectionsFeatureStatus,
        couponsFeatureStatus: couponsFeatureStatus,
        crrFeatureStatus: crrFeatureStatus,
        fbPixelFeatureStatus: fbPixelFeatureStatus,
        googleAnalyticsFeatureStatus: googleAnalyticsFeatureStatus,
        googleTagFeatureStatus: googleTagFeatureStatus,
        installAppFeatureStatus: installAppFeatureStatus,
        leadGenFeatureStatus: leadGenFeatureStatus,
        visitorLoginFeatureStatus: visitorLoginFeatureStatus,
        isEcommExpired: isEcommExpired,
        notifyMeFeatureStatus: notifyMeFeatureStatus,
        partialPaymentFeatureStatus: partialPaymentFeatureStatus,
        memberOnlyLoginFeatureStatus: memberOnlyLoginFeatureStatus
    };
}


/***/ }),

/***/ 99375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68037);
/* harmony import */ var src_utils_getContactDetails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60492);


var useStoreContactDetails = function() {
    var hideOwnerPhone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var storeData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return (0,src_utils_getContactDetails__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(storeData, true, hideOwnerPhone);
};
/* harmony default export */ __webpack_exports__["Z"] = (useStoreContactDetails);


/***/ }),

/***/ 68037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IU": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.IU; },
/* harmony export */   "Vn": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.Vn; },
/* harmony export */   "kF": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.kF; },
/* harmony export */   "u": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.u; },
/* harmony export */   "v9": function() { return /* reexport safe */ _reducers__WEBPACK_IMPORTED_MODULE_0__.v; },
/* harmony export */   "wm": function() { return /* reexport safe */ _ssrStore__WEBPACK_IMPORTED_MODULE_1__.wm; }
/* harmony export */ });
/* harmony import */ var _reducers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1532);
/* harmony import */ var _ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20155);




/***/ }),

/***/ 85126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ executeLogout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56173);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66162);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68060);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44541);
/**
 * common logout component. After logout
 * is initiated, if successful
 * reroute to product
 */ 





function executeLogout() {
    var ref, ref1, ref2;
    var storeData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer) === null || ref === void 0 ? void 0 : ref.store;
    var cartData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
    localStorage.clear();
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .setLogout */ .wt)());
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cartData), {
        items: [],
        store_offer: {},
        payment_offer: {}
    })));
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .removeSelectedAddress */ .uz)());
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .saveAddressList */ .Af)({
        addressList: [],
        defaultAddress: {}
    }));
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)((storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.custom_theme_flag) ? _routes__WEBPACK_IMPORTED_MODULE_2__.PATH.PRODUCT : _routes__WEBPACK_IMPORTED_MODULE_2__.PATH.SHOP, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
}


/***/ }),

/***/ 33104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getContrastingColor; }
/* harmony export */ });
/**
 * return the black/white color based on the contrast.
 * @param {*} bgColor background color given to header
 * @return {string} return black when contrast is high and vice versa
 */ function getContrastingColor(bgColor) {
    var lightColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, darkColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var c = bgColor === null || bgColor === void 0 ? void 0 : bgColor.substring(1);
    var rgb = parseInt(c, 16);
    var r = rgb >> 16 & 0xff;
    var g = rgb >> 8 & 0xff;
    var b = rgb >> 0 & 0xff;
    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    if (luma < 127) {
        return lightColor || "#ffffff";
    } else {
        return darkColor || "#000000";
    }
}


/***/ }),

/***/ 36623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);



/** This utility function returns custom cta texts, certain labels based on is the store deliverying orders or
 * booking services
 * @param {string} type -> type of text you want
 * @return {string} -> text you wanted
 */ var getCustomCtaText = function(type) {
    var _store = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store, theme = _store.theme, services = _store.services;
    var isStoreServiceBased = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED && (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() != _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    var isExtraChargeForCODActive = (services === null || services === void 0 ? void 0 : services.cod_charge_flag) > _constants__WEBPACK_IMPORTED_MODULE_2__/* .COD_CHARGE_TYPE.FREE */ .VV.FREE;
    var getBillConfirmedHeading = function() {
        switch((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)()){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED:
                return "Order placed successfully!";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B:
                return "Request submitted Successfully";
            default:
                return "Booked Successfully";
        }
    };
    var getBillOrderIdLabel = function() {
        var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
        switch(cart.order_type){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE:
                return "Your Booking ID:";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.B2B */ .Jm.B2B:
                return "Your Request ID:";
            default:
                return "Your Order ID:";
        }
    };
    switch(type){
        case "my_orders_cta":
            var ref, ref1;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.my_orders) return theme === null || theme === void 0 ? void 0 : (ref1 = theme.cta_config) === null || ref1 === void 0 ? void 0 : ref1.my_orders;
            else if (isStoreServiceBased) return "My Bookings";
            else return "My Orders";
        case "bill_confirm_heading":
            return getBillConfirmedHeading();
        case "placing_order_cta":
            if (isStoreServiceBased) return "Booking your Service";
            else return "Placing Your Order";
        case "buy_now_cta":
            var ref2, ref3;
            if (theme === null || theme === void 0 ? void 0 : (ref2 = theme.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_cta) return theme === null || theme === void 0 ? void 0 : (ref3 = theme.cta_config) === null || ref3 === void 0 ? void 0 : ref3.pdp_cta;
            else if (isStoreServiceBased) return "Book Now";
            else "Buy NOW";
        case "empty_cart_cta":
            return isStoreServiceBased ? "Book Now" : "Shop Now";
        case "banner_cta":
            var ref4, ref5;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.banner_cta) return theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.banner_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Shop Now";
        case "order_instructions_label":
            if (isStoreServiceBased) return "Booking Instructions";
            else return "Order Instructions";
        case "cart_cta":
            var ref6, ref7;
            if (theme === null || theme === void 0 ? void 0 : (ref6 = theme.cta_config) === null || ref6 === void 0 ? void 0 : ref6.postpaid_cart_cta) return theme === null || theme === void 0 ? void 0 : (ref7 = theme.cta_config) === null || ref7 === void 0 ? void 0 : ref7.postpaid_cart_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Place Order";
        case "item_total_label":
            if (isStoreServiceBased) return "Total";
            else return "Item Total";
        case "order_summary_heading":
            if (isStoreServiceBased) return "Summary";
            else return "Order Summary";
        case "item_details_heading":
            if (isStoreServiceBased) return "Details";
            else return "Item Details";
        case "widget_cta":
            if (isStoreServiceBased) return "Book Now";
            else return "Explore Now";
        case "cart_confirm_cta":
            {
                var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
                var isOrderServiceType = cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE;
                if (isOrderServiceType) return "Pay after service";
                else if (cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                else return "Pay on Pickup";
            }
        case "pay_after_cta":
            if (isStoreServiceBased) return "Pay after Service using";
            else return "Pay on Delivery / Pickup using";
        case "other_payment_modes_cta":
            if (isStoreServiceBased) return "Pay after service";
            else {
                var _orderDetails = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().orderReducer.orderDetails, prepaid_flag = _orderDetails.prepaid_flag, order_type = _orderDetails.order_type;
                if (prepaid_flag === 1) {
                    if (order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                    else return "Pay On Pick Up";
                } else return "Cash On Delivery";
            }
        case "bill_order_id":
            {
                return getBillOrderIdLabel();
            }
        case "order_list_heading":
            return isStoreServiceBased ? "My Bookings" : "My Orders";
        default:
            return "";
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getCustomCtaText);


/***/ }),

/***/ 30066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nz": function() { return /* binding */ getWhatAppRedirectionUrlHelp; },
/* harmony export */   "eo": function() { return /* binding */ getWhatAppRedirectionUrlCODRequest; },
/* harmony export */   "gi": function() { return /* binding */ getWhatAppRedirectionUrl; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _getContactDetails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60492);


function getWhatAppRedirectionUrlHelp() {
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var message = "Hi%2C%0D%0A%0D%0AI+am+at+your+online+store+and+need+some+help.%0D%0A%0D%0A".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.store_url);
    return getWhatAppRedirectionUrl(message);
}
function getWhatAppRedirectionUrlCODRequest(payAmount, orderId) {
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var message = "Hi%2C%0AI%20would%20pay%20Rs.".concat(payAmount, "%20in%20*cash*%20for%20the%20*Order%20%23*%20-%20").concat(orderId, "%0Athat%20was%20placed%20at%20your%20online%20store%20-%20%0A").concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.store_url);
    return getWhatAppRedirectionUrl(message);
}
function getWhatAppRedirectionUrl() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var storePhone = (0,_getContactDetails__WEBPACK_IMPORTED_MODULE_1__/* .getVisibleStorePhone */ .qQ)(storeData);
    return "https://api.whatsapp.com/send?phone=+91".concat(storePhone, "&text=").concat(message);
}


/***/ }),

/***/ 20503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _getCustomCtaText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36623);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24686);


function getOrdersDropdownList() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ordersDropdownList = [
        {
            id: 1,
            name: "000000000",
            action: "defaultPhone"
        },
        {
            id: 2,
            name: (0,_getCustomCtaText__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("my_orders_cta"),
            action: "orders"
        },
        {
            id: 3,
            name: "Logout",
            action: "logout"
        }, 
    ];
    var userContact = ((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.userReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.phone) || ((ref3 = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState()) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.userReducer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.email);
    ordersDropdownList[0].name = userContact;
    var isVisitorLoginVisible = (ref6 = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState()) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.commonReducer) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.featureLocksData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.featureLocks) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["visitorLogin"]) === null || ref10 === void 0 ? void 0 : ref10.isVisible;
    return ordersDropdownList.slice(0, !isVisitorLoginVisible ? 2 : undefined);
}
/* harmony default export */ __webpack_exports__["Z"] = (getOrdersDropdownList);


/***/ })

}]);